<template>
  <div class="expmangecate" >
    <el-divider content-position="left">快递内容分类</el-divider>
    <div style="display: flex">
      <el-select
        v-model="searchArr.category_id"
        filterable
        remote
        reserve-keyword
        placeholder="请输入分类名称"
        size="mini"
        clearable
        :remote-method="searchRemoteCfcategory"
        :loading="searchLoading"
        @change="handleSearchCfcategory"
      >
        <el-option
          v-for="searchCompany in searchCategories"
          :key="searchCompany.id"
          :label="searchCompany.category_name"
          :value="searchCompany.id"
        >
        </el-option>
      </el-select>
      <div style="text-align: right; flex: 1">
        <el-button type="primary" size="mini" @click="categoryIn"
          >录入</el-button
        >
      </div>
    </div>
    <el-drawer
      title="录入"
      :visible.sync="categoryIndrawer"
      :direction="direction"
      :before-close="handleClose"
      size="40%"
    >
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <el-form
          :model="categoryForm"
          :rules="rules"
          ref="categoryForm"
          label-width="100px"
        >
          <el-form-item label="分类名称" prop="categoryId">
            <el-input v-model="categoryForm.categoryId" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="是否显示" prop="display">
            是
            <el-switch
              v-model="categoryForm.display"
              active-color="#ff4949"
              inactive-color="#13ce66"
            >
            </el-switch>
            否
          </el-form-item>
          <div style="text-align: right">
            <el-button
              type="primary"
              size="mini"
              @click="submitForm('categoryForm')"
              >添加</el-button
            >
          </div>
        </el-form>
      </div>
    </el-drawer>
    <el-drawer
      title="修改"
      :visible.sync="categoryEditDrawer"
      :direction="direction"
      :before-close="handleClose"
      size="40%"
    >
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <el-form
          :model="editCategoryForm"
          :rules="rules"
          ref="editCategoryForm"
          label-width="100px"
        >
          <el-form-item label="分类名称" prop="categoryId">
            <el-input
              v-model="editCategoryForm.categoryId"
              size="mini"
            ></el-input>
          </el-form-item>
          <el-form-item label="是否显示" prop="display">
            是
            <el-switch
              v-model="ifDisplay"
              active-color="#ff4949"
              inactive-color="#13ce66"
            >
            </el-switch>
            否
          </el-form-item>
          <div style="text-align: right">
            <el-button
              type="primary"
              size="mini"
              @click="editSubmitForm('editCategoryForm')"
              >修改</el-button
            >
          </div>
        </el-form>
      </div>
    </el-drawer>
    <el-table
      max-height="650"
      :data="categoryData"
      style="width: 100%; margin-top: 10px"
      border
      size="mini"
      :header-cell-style="{
        background: '#ecf4ff',
        color: '#333',
        fontWeight: '900',
        fontSize: '0.28rem',
      }"
    >
      <el-table-column prop="id" label="ID"> </el-table-column>
      <el-table-column prop="category_name" label="分类名称"> </el-table-column>
      <el-table-column prop="display" label="是否显示">
        <template slot-scope="scope">
          是
          <el-switch
            v-model="ListIfDisplay[scope.row.id]"
            active-color="#ff4949"
            inactive-color="#13ce66"
            @click.native="editListRadio(scope.row)"
          >
          </el-switch>
          否
        </template>
      </el-table-column>
      <el-table-column prop="sort" label="排序">
        <template slot-scope="scope">
          <el-input
            type="number"
            size="mini"
            v-model="listSort[scope.row.id]"
            @blur="setSort(scope.row)"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="修改" placement="top">
            <el-button
              @click.native.prevent="editRow(scope.$index, categoryData)"
              type="primary"
              size="mini"
              icon="el-icon-edit"
              circle
            >
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <div class="block" style="margin-top: 10px; text-align: right">
      <el-pagination
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        layout="sizes, total, prev, pager, next, jumper"
        :total="total"
        :page-sizes="[10, 15, 30, 50, 100]"
        :page-size="categoryPerPage"
        background
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExpManageCate',
  data () {
    var categoryId = (rule, value, callback) => {
      if (value.length > 100) {
        return callback(new Error('输入过长！'))
      }
      if (value.length === 0) {
        return callback(new Error('请输入分类名称！'))
      }
      callback()
    }
    return {

      searchArr: {
        category_id: ''
      },
      npage: 1,
      categoryPerPage: 10,
      total: null,
      listSortForm: [],
      categoryData: [],
      searcher: null,
      categoryEditDrawer: false,
      searchLoading: false,
      searchCategories: [],
      categoryIndrawer: false,
      direction: 'rtl',
      ifDisplay: false,
      ListIfDisplay: [],
      listSort: [],
      category: '',
      categoryForm: {
        categoryId: '',
        category_name: '',
        display: false
      },
      editCategoryForm: {
        categoryId: '',
        category_name: '',
        display: false
      },
      rules: {
        categoryId: [
          {
            validator: categoryId,
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    collapse () {
      return this.$store.state.collapse
    }
  },
  mounted () {
    this.loadTable()
  },
  // watch: {
  //   searcher: function (n, o) {
  //     this.loadTable(n)
  //   }
  // },
  methods: {
    loadTable () {
      this.$axios
        .get('api/expmanagecate/index', {
          params: {
            page: this.npage,
            perpage: this.categoryPerPage,
            searchItem: this.searcher
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.categoryData = data.data.data
            this.total = data.data.total
            this.loadRadio()
            this.loadSort()
          }
        })
        .catch()
    },
    loadRadio () {
      this.categoryData.map(item => {
        if (item.display === 1) {
          this.ListIfDisplay[item.id] = false
        } else {
          this.ListIfDisplay[item.id] = true
        }
      })
    },
    loadSort () {
      this.categoryData.map(item => {
        this.listSort[item.id] = Number(item.sort)
      })
    },
    handleCurrentChange (val) {
      this.npage = val
      this.loadTable()
    },
    handleSizeChange (val) {
      this.categoryPerPage = val
      this.loadTable()
    },
    editRow (index, data) {
      this.$axios
        .get('api/expmanagecate/show', {
          params: {
            id: data[index].id
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            if (data.data.display === 1) {
              this.ifDisplay = false
            } else {
              this.ifDisplay = true
            }
            this.editCategoryForm.categoryId = data.data.category_name
            this.category = data.data.id
          }
        })
        .catch()
      this.categoryEditDrawer = true
    },
    searchRemoteCfcategory (query) {
      if (query !== '') {
        this.searchLoading = true
        setTimeout(() => {
          this.searchLoading = false
          this.searchItem(query)
        }, 200)
      } else {
        this.searchCategories = []
      }
    },
    searchItem (query) {
      this.$axios
        .get('api/expmanagecate/getitem', {
          params: {
            search: query
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.searchCategories = data.data
          }
        })
        .catch()
    },
    handleSearchCfcategory (query) {
      this.searcher = query
      setTimeout(() => {
        this.loadTable()
      })
    },
    categoryIn () {
      this.categoryIndrawer = true
    },
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$axios
            .post('api/expmanagecate/store', {
              category_name: this.categoryForm.categoryId,
              display: this.categoryForm.display === false ? 1 : 0
            })
            .then(res => {
              const { data } = res
              if (data.code === 1) {
                this.$message.success(data.msg)
                this.categoryIndrawer = false
                this.resetForm('categoryForm')
                this.loadTable()
              } else {
                this.$message.error(data.msg)
              }
            })
            .catch()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    editSubmitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$axios
            .put('api/expmanagecate/edit', {
              id: this.category,
              category_name: this.editCategoryForm.categoryId,
              display: this.ifDisplay === false ? 1 : 0
            })
            .then(res => {
              const { data } = res
              if (data.code === 1) {
                this.$message.success(data.msg)
                this.categoryEditDrawer = false
                this.loadTable()
              } else {
                this.$message.error(data.msg)
              }
            })
            .catch()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    editListRadio (row) {
      this.$axios
        .put('api/expmanagecate/listshow', {
          id: row.id,
          display: this.ListIfDisplay[row.id] === false ? 1 : 0
        })
        .then(res => {
          const { data } = res
          if (data.code === 1) {
            this.$message.success(data.msg)
            this.loadTable()
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    setSort (row) {
      if (isNaN(this.listSort[row.id])) {
        this.$message.error('排序值为数字！')
        return false
      }
      this.$axios
        .put('api/expmanagecate/setsort', {
          id: row.id,
          sort: this.listSort[row.id]
        })
        .then(res => {
          const { data } = res
          if (data.code === 1) {
            this.$message.success(data.msg)
            this.loadTable()
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style  scoped>
.expmangecate {
  /* margin-left: 3.6rem; */
  padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/exp_manage/ExpManageCate.vue